import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'
import { useAuth } from '../contexts/auth-context'

export function HomePage() {
	const { isAdmin, hasCompanyAssignment } = useAuth()
	const navigate = useNavigate()

	useEffect(() => {
		// Redirect logic based on user permissions
		if (hasCompanyAssignment) {
			// User has company assignment (with or without admin) -> go to sensors
			navigate('/sensors', { replace: true })
		} else if (isAdmin) {
			// User is admin but no company assignment -> go to admin portal
			navigate('/admin-portal', { replace: true })
		} else {
			// User has neither admin nor company assignment -> blocked
			navigate('/no-company', { replace: true })
		}
	}, [isAdmin, hasCompanyAssignment, navigate])

	// Show loading spinner while redirecting
	return (
		<Box 
			display="flex" 
			justifyContent="center" 
			alignItems="center" 
			minHeight="70vh"
		>
			<CircularProgress />
		</Box>
	)
}
